import { CommonModule } from '@angular/common'
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core'
import { RouterModule } from '@angular/router'
import { Subscription } from 'rxjs'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { DdcLoggerService } from 'src/app/service/log/ddc-logger.service'
import { ThemeService } from 'src/app/service/theme/theme.service'
import { DaydicTypesIconNames, Media, Themes } from '../../enums/enums'
import { SimpleDictionary } from '../../models/main/dictionary'
import { Privacy } from '../../models/main/privacy'
import { DdcUserSubscription } from '../../models/main/subscription'
import { DdcCardCategoryComponent } from '../ddc-card-category/ddc-card-category.component'
import { DdcCountryFlagComponent } from '../ddc-country-flag/ddc-country-flag.component'
import { DdcDicSComponent } from '../ddc-dic-s/ddc-dic-s.component'
import { DdcProfilePicOnlyComponent } from '../ddc-profile-pic-only/ddc-profile-pic-only.component'
@Component({
  selector: 'ddc-profile-pic',
  templateUrl: './ddc-profile-pic.component.html',
  styleUrl: './ddc-profile-pic.component.scss',
  encapsulation: ViewEncapsulation.Emulated,
  standalone: true,
  imports: [
    AngularMaterialsModules,
    CommonModule,
    RouterModule,
    DdcCountryFlagComponent,
    DdcDicSComponent,
    DdcCardCategoryComponent,
    DdcProfilePicOnlyComponent,
  ],
})
export class DdcProfilePicComponent implements OnInit {
  @Input('isProfilePicLoading') _isProfilePicLoading: boolean
  @Input('username') _username: string
  @Input('userProfilePic') _userProfilePic: string
  @Input('dynamicRoute') _dynamicRoute: string
  @Input('followerCount') followerCount?: number
  @Input('creationTime') creationTime?: string = ''
  @Input('privacy') privacy: Privacy
  @Input('language_1') language_1?: string
  @Input('language_2') language_2?: string
  @Input('simple') simple?: boolean = false
  @Input('minimal') minimal?: boolean = false
  @Input('subscription') _subscription?: DdcUserSubscription
  @Input('dictionaries') _dictionaries?: SimpleDictionary[] = []
  @Input('category') _category?: string = undefined
  @Input('dic_words') _dic_words?: number = undefined
  @Input('dic_pairs') _dic_pairs?: number = undefined
  @Input('verified') _verified?: boolean = false
  @Input('contentType') contentType?: string

  get contentTypeIcon(): string {
    switch (this.contentType) {
      case 'word':
        return DaydicTypesIconNames.WORD
      case 'pair':
        return DaydicTypesIconNames.PAIR
      case 'dictionary':
        return DaydicTypesIconNames.DICTIONARY
      case 'note':
        return DaydicTypesIconNames.NOTE
      case 'quiz':
        return DaydicTypesIconNames.QUIZ
      case 'figure':
        return DaydicTypesIconNames.FIGURE
      default:
        return ''
    }
  }

  get contentTypeTooltip(): string {
    switch (this.contentType) {
      case 'word':
        return 'Word'
      case 'pair':
        return 'Pair'
      case 'dictionary':
        return 'Dictionary'
      case 'note':
        return 'Note'
      case 'quiz':
        return 'Quiz'
      case 'figure':
        return 'Figure'
      default:
        return ''
    }
  }

  get privacyIcon(): string {
    switch (this.privacy) {
      case 'P01':
        return 'public'
      case 'P02':
        return 'group'
      case 'P03':
        return 'lock'
      default:
        return 'public'
    }
  }

  get privacyTooltip(): string {
    switch (this.privacy) {
      case 'P01':
        return 'Public'
      case 'P02':
        return 'Followers'
      case 'P03':
        return 'Only Me'
      default:
        return 'Public'
    }
  }

  _assets = Media.ASSETS

  _isLightTheme: boolean = true
  _isDarkTheme: boolean = false
  _isPaperTheme: boolean = false
  private themeSubscription: Subscription

  _DefaultProfilePic: string =
    'https://st3.depositphotos.com/6672868/13701/v/600/depositphotos_137014128-stock-illustration-user-profile-icon.jpg'

  constructor(
    private logger: DdcLoggerService,
    public themeService: ThemeService,
  ) {
    this.themeSubscription = this.themeService.theme$.subscribe(theme => {
      this._isLightTheme = theme === Themes.LIGHT
      this._isDarkTheme = theme === Themes.DARK
      this._isPaperTheme = theme === Themes.PAPER
    })
  }
  ngOnInit(): void {
    if (
      this._userProfilePic === null ||
      this._userProfilePic === undefined ||
      this._userProfilePic === 'null'
    ) {
      this._assets = Media.EMPTY
      this._userProfilePic = this._DefaultProfilePic
    }
  }
}
